import { render, staticRenderFns } from "./reviewers.vue.js?vue&type=template&id=d7861b3c!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./reviewers.vue?vue&type=template&id=d7861b3c"
import script from "./reviewers.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./reviewers.vue?vue&type=script&lang=js"
export * from "./reviewers.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./reviewers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports